module.exports = foundation;